import React from "react"
import {
  actualiteInfos,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteContainerFirst,
} from "../actualites.module.scss"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import { summaryLength } from "../../../../constants"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { Taxo, ActualiteTitle, ActualiteResume } from "./actu-item-styled"
import PropTypes from "prop-types"

const ActuItem = ({ actu, myClassName }) => {
  let image = ""
  let title = ""
  if (myClassName === actualiteContainerFirst) {
    image = (
      <NonStretchedImage {...actu.relationships.field_image_actus?.localFile} />
    )
    title = <div>{actu.title}</div>
  } else {
    image = (
      <TransitionFade arialabel={actu.title} link={actu.path.alias}>
        <NonStretchedImage
          {...actu.relationships.field_image_actus?.localFile}
          ariaHidden={true}
        />
      </TransitionFade>
    )
    title = <TransitionFade link={actu.path.alias}>{actu.title}</TransitionFade>
  }
  return (
    <div className={myClassName}>
      {actu.relationships.field_image_actus?.localFile && <>{image}</>}
      <div className={actualiteInfos}>
        {actu.relationships.field_taxonomie_thematique?.length > 0 && (
          <div className={actualiteCategorie}>
            <Taxo>{actu.relationships.field_taxonomie_thematique[0].name}</Taxo>
          </div>
        )}
        <ActualiteTitle className={actualiteTitle}>{title}</ActualiteTitle>
        {actu.body && (
          <ActualiteResume
            className={actualiteResume}
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(actu.body, summaryLength),
            }}
          />
        )}
      </div>
    </div>
  )
}

ActuItem.propTypes = {
  actu: PropTypes.object.isRequired,
  myClassName: PropTypes.string.isRequired,
}

export default ActuItem
